import { defineStore, acceptHMRUpdate } from 'pinia'
import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export type LayoutOption = 'default' | 'float'

export const useLayoutPreferencesStore = defineStore(
  'layoutPreferences',
  () => {
    // STATE ========================================================================
    const forcedLayout = ref<LayoutOption | null>(null)
    const defaultLayout = useLocalStorage<LayoutOption>(
      'defaultLayout',
      'default',
    )

    // Available layout options with their display names
    const layoutOptions = [
      { value: 'default', label: 'Default' },
      { value: 'float', label: 'Float' },
    ]

    // ACTIONS ======================================================================
    function setDefaultLayout(layout: LayoutOption) {
      defaultLayout.value = layout
    }

    function setForcedLayout(layout: LayoutOption | null) {
      forcedLayout.value = layout
    }

    // GETTERS ======================================================================
    const currentLayout = computed(
      () => forcedLayout.value ?? defaultLayout.value,
    )

    return {
      defaultLayout,
      layoutOptions,
      currentLayout,
      setDefaultLayout,
      setForcedLayout,
    }
  },
)

// Enable HMR for this store
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useLayoutPreferencesStore, import.meta.hot),
  )
}
